import React from 'react';
import { Translation } from '../components/translation/translation';

export const getTranslationElement = (key, placeholder = {}, additionalArgs = {}) => (
    <Translation
        key={key}
        translationKey={key}
        placeholder={placeholder}
        { ...additionalArgs }
    />
);
